<template>
  <div>
    <ckeditor :editor="editor" v-model="editorData" :config="editorConfig" @ready="onReady"></ckeditor>
  </div>
</template>

<script>
import Vue from 'vue'
import store from '@/store'
import { getAction, uploadAction } from '@/api/manage'
import ClassicEditor from 'teaching-ckeditor5'
import CKEditor from '@ckeditor/ckeditor5-vue2'

class MyUploadAdapter {
  constructor(loader) {
    this.loader = loader
    this.qnToken = ''
  }

  async upload() {
    const _this = this
    let file = await this.loader.file
    return new Promise((resolve, reject) => {
      _this.getQnToken().then((res) => {
        console.log('upload', file)
        const formData = new FormData()
        formData.append('file', file, _this.uuidGenerator() + file.name)
        formData.append('token', res.result)
        formData.append('key', store.getters.tenantInfo.tenantId + '/html/' + _this.uuidGenerator() + file.name)
        uploadAction(_this.getUploadUrl(), formData, function (progressEvent) {}).then((res) => {
          if (res.key) {
            let url = _this.getDownloadUrl(res.key)
            console.log('url', url)
            resolve({ default: url })
          } else {
            reject(res)
          }
        })
      })
    })
  }
  // 中止上载过程
  abort() {}
  // 获取七牛token
  getQnToken() {
    let that = this
    return new Promise((resolve, reject) => {
      getAction('/common/qiniu/getToken', {}).then((token_res) => {
        if (token_res.success) {
          that.qnToken = token_res.result
          Vue.ls.set('ckeditorQnToken', token_res.result, 600000)
          resolve(token_res)
        }
      })
    })
  }
  getUploadUrl() {
    return '//upload-' + store.getters.tenantInfo.qiniuArea + '.qiniup.com'
  }
  getDownloadUrl(filepath) {
    return store.getters.tenantInfo.qiniuDomain + '/' + filepath
  }
  uuidGenerator() {
    var s = []
    var hexDigits = '0123456789abcdef'
    for (var i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
    }
    s[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = '-'
    var uuid = s.join('')
    return uuid
  }
}

function MyCustomUploadAdapterPlugin(editor) {
  editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
    // 在这里将URL配置为后端上载脚本
    return new MyUploadAdapter(loader)
  }
}

export default {
  name: 'ClassicEditor',

  components: {
    //局部注册方式
    ckeditor: CKEditor.component,
  },

  props: {
    value: {
      type: String,
      required: false,
    },
    content: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '请输入内容',
    },
    triggerChange: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  watch: {
    value(newValue) {
      this.editorData = newValue == null ? '' : newValue
    },
    editorData(newValue) {
      if (this.triggerChange) {
        this.$emit('change', newValue)
      } else {
        this.$emit('input', newValue)
      }
    },
  },
  data() {
    return {
      // Use the <ckeditor> component in this view.
      editor: ClassicEditor,
      editorData: '',
      editorConfig: {
        placeholder: this.placeholder,
        language: 'zh-cn',
        toolbar:{
          shouldNotGroupWhenFull:true,
          items: [
            'heading',
            '|',
            'bold',
            'italic',
            'underline',
            'link',
            'bulletedList',
            'numberedList',
            '|',
            'outdent',
            'indent',
            'alignment',
            'horizontalLine',
            '|',
            // 'imageUpload',
            'imageInsert',
            'blockQuote',
            'insertTable',
            'mediaEmbed',
            'undo',
            'redo',
            '|',
            'fontSize',
            'highlight',
            'fontColor',
            'fontBackgroundColor',
            '|',
            'codeBlock',
            'sourceEditing',
            'htmlEmbed',
            'code',
            // 'ckbox'
          ]
        },
        extraPlugins: [MyCustomUploadAdapterPlugin],
      },
    }
  },
  created(){
  },
  methods: {
    onReady(){
      console.log("ckeditor ready");
      this.editorData = this.value
    },
    getContent() {
      return this.editorData
    },
    setContent(val) {
      this.editorData = val
    },
  },
}
</script>

<style>
.ck-content {
   min-height: 200px;
}
.ck-editor__editable {
  min-height: 200px;
}
.ck-editor__editable_inline {
  max-height: 500px;
}
</style>
